// global store
import Vue from 'vue';
import Vuex, { StoreOptions, Payload } from 'vuex';

Vue.use(Vuex);

import { GlobalState } from './types';
import { auth } from './auth';
import { sessions } from './sessions';
import { destinations } from './destinations';
import { links } from './links';
import { sitenotify } from './sitenotify';
import { users } from './users';
import { config } from '@/api/myeta/';

const storeOptions: StoreOptions<GlobalState> = {
    modules: {
        ['$auth']: auth,
        ['$sessions']: sessions,
        ['$destinations']: destinations,
        ['$links']: links,
        ['$sitenotify']: sitenotify,
        ['$users']: users,
    },
};

const store = new Vuex.Store<GlobalState>(storeOptions);
export default store;

// configure auth
store.dispatch('$auth/init', {
  userPoolId: 'us-west-2_A2Ro0A3uL',
  identityPoolId: 'us-west-2:256bbc9a-b1d8-4fca-8a42-86e5bb1ae3bc',
  userPoolWebClientId: '20cetl0rhtmd42nvi3aq95a9fk',
  region: 'us-west-2',
});

// configure api
config.setToken(() => {
    return store.getters['$auth/accessToken'];
});